import { Download, Photo } from "@mui/icons-material";
import { Box, Button, SxProps } from "@mui/material";
import { useStore } from "@priolo/jon";
import attachApi from "api/attachments";
import Modal from "components/controls/Modal";
import { FunctionComponent, useState } from "react";
import farmSo from "stores/farm";
import attachSo from "stores/attachment";
import { downloadBlob } from "utils/net";
import ImageCmp from "./ImageCmp";
import ImageBlobCmp from "./ImageBlobCmp";



interface Props {
}

const PhotoDialog: FunctionComponent<Props> = ({
}) => {

    // STORE
    useStore(attachSo)

    // HOOKs
    const [real, setReal] = useState(false)

    // HANDLEs
    const handleClose = () => attachSo.setDialogOpen(false)

    const handleDownlod = async () => {
        const photo = attachSo.state.selected
        if (!photo) return
        const farmId = farmSo.state.select?.id
        const blob = await attachApi.download(farmId, photo.id)
        downloadBlob(blob, photo.name ?? "photo.jpg")
    }

    // RENDER
    const photo = attachSo.state.selected
    if (!photo) return null

    return <Modal
        icon={<Photo />}
        maxWidth={real ? false : undefined}
        title={photo.name ?? "PHOTO"}
        isOpen={attachSo.state.dialogOpen}
        onClose={handleClose}
        actionsRender={<>

            <Button
                startIcon={<Download />}
                onClick={handleDownlod}
            >DOWNLOAD</Button>

            <div style={{ flex: "1 1 auto" }} />
            <Button
                onClick={handleClose}
            >CLOSE</Button>

        </>}
    >

        {!!photo.thumbnailTemporaryUrl ? (
            <ImageCmp sx={sxImage}
                url={photo.thumbnailTemporaryUrl}
                onClick={() => setReal(!real)}
            />
        ) : (
            <ImageBlobCmp sx={sxImage}
                attach={photo}
                onClick={() => setReal(!real)}
            />
        )}

        {photo.userNotes && (
            <Box sx={sxNotes}>
                {photo.userNotes}
            </Box>
        )}

    </Modal>
}

export default PhotoDialog

const sxImage: SxProps = {
    minHeight: "200px",
}

const sxNotes: SxProps = {
    mt: 2,
    maxHeight: '150px',
    overflow: 'auto',
    padding: 1,
    borderRadius: 1,
    bgcolor: '#000',
    fontSize: '14px',
}